import {
  Text,
  Font,
  Document,
  Page,
  StyleSheet,
  View,
  Link,
  Image,
} from "@react-pdf/renderer";
import imagePlaceholder from "../../assets/logo.png";
import { keys } from "../../config/keys";
import { Checkbox } from "@mui/material";
import checkmark from "../../assets/checkmark.png";
import { convertDateToDDMMYYYY } from "../../config/functions";
Font.register({
  family: "Nunito",
  fonts: [
    {
      src: require("../../assets/fonts/NunitoSans-Regular.ttf"),
      fontWeight: "normal",
    },
    {
      src: require("../../assets/fonts/NunitoSans-Bold.ttf"),
      fontWeight: "bold",
    },
    {
      src: require("../../assets/fonts/NunitoSans-Light.ttf"),
      fontWeight: "light",
    },
    {
      src: require("../../assets/fonts/NunitoSans-SemiBold.ttf"),
      fontWeight: "600",
    },
    // Add more font weights as needed
  ],
});

const styles = StyleSheet.create({
  image: {
    width: 20,
    height: 20,
    marginBottom: 10,
  },
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
    backgroundColor: "white",
  },
  title: {
    fontSize: 24,
    textAlign: "center",
    fontFamily: "Nunito",
    fontWeight: "bold",
    color: "#012970",
  },
  author: {
    fontSize: 12,
    textAlign: "center",
    marginBottom: 40,
    fontFamily: "Nunito",
    fontWeight: "normal",
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    fontFamily: "Nunito",
    fontWeight: "bold",
  },
  card: {
    backgroundColor: "white",
    borderRadius: 10,
    padding: 20,
  },
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottomWidth: 0.4,
  },
  question: {
    fontSize: 14,
    wordBreak: "break-all",
    padding: 10,
    textAlign: "left",
    fontFamily: "Nunito",
    width:'300px'
  },
  answer: {
    // flex: 2,
    fontSize: 14,
    padding: 10,
    textAlign: "right",
    fontFamily: "Nunito",
    fontWeight: "normal",
    // textAlign: "right",
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: "center",
    color: "grey",
    fontFamily: "Nunito",
    fontWeight: "light",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  pageDate: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "right",
    color: "grey",
    marginRight: 35,
  },
  checkboxContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
  },
  checkbox: {
    width: 32,
    height: 32,
    borderWidth: 1,
    borderColor: "black",
    color: "black",
    marginRight: 5,
    textAlign: "center",
    fontSize: 10,
    // fontFamily: 'Nunito',
  },
  label: {
    fontSize: 12,
  },
});

const PDF = ({ data }) => {
  const image = data?.companyID?.imageURL
    ? `${keys.BASE_LOCAL_URL}/${data?.companyID?.imageURL}`
    : imagePlaceholder;
    // helper: insert zero-width every N chars

  const capitaliseFirstLetter = (str) => {
  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
  return (
    <Document>
      <Page style={styles.body}>
        <Text style={styles.header} fixed>
        CompCheck.io
        </Text>
        <Text style={styles.header} fixed>
          {data?.companyID?.name}
        </Text>
        <View
          style={{
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Image
            src={image}
            style={{ maxWidth: 150, maxHeight: 150, marginBottom: 10 }}
          />
          <Text style={styles.title}>
            {capitaliseFirstLetter(data?.forFeature)}
          </Text>
        </View>
        <View style={styles.card}>
          <View>
            {data?.shareableID?.shareable?.map((item, index) => (
              <View key={index} style={styles.container}>
                <Text style={styles.question}>{item.title ?? item.name}</Text>
                {item.lastReviewed ? (
                  <Text style={styles.answer}>
                    {convertDateToDDMMYYYY(item.lastReviewed)}
                  </Text>
                ) : (
                  <Text style={styles.answer}>
                    {convertDateToDDMMYYYY(item.createdAt)}
                  </Text>
                )}
                {item.url && (
                  <Link
                    src={`${keys.BASE_LOCAL_URL}/${item.url}`}
                    style={styles.answer}
                  >
                    View
                  </Link>
                )}
              </View>
            ))}
          </View>
        </View>
        <View>
          <View style={styles.checkboxContainer}>
            <Image
              src={checkmark}
              style={{ width: 15, height: 15, marginRight: 10 }}
            />
            <Text style={styles.label}>
              {`I hereby confirm that I have received, read, understood and agree to the contents of the attached document(s).`}
            </Text>
          </View>
        </View>
        <View>
          <Image
            src={`${keys.BASE_LOCAL_URL}/${data.signature}`}
            style={{ width: 200, height: 70, marginTop: 80 }}
          />
        </View>
        <View
          style={{ width: "150px", borderBottom: "1px solid black", marginTop:'8px' }}
        ></View>
        <Text style={{...styles.label, marginLeft:'50px', marginTop:'15px'}}>{`Signature`}</Text>
        {data.submittedName && <Text style={{...styles.label,  marginTop:'15px'}}>{`Name: ` + data.submittedName}</Text>}
        <Text style={{...styles.label,  marginTop:'15px'}}>{`Email: ` + data.submittedEmail}</Text>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
        <Text
          style={styles.pageDate}
          render={() => new Date(data?.createdAt).toLocaleDateString("en-GB")}
          fixed
        />
      </Page>
    </Document>
  );
};

export default PDF;
